import * as yup from 'yup'
import {
  NUMERIC_FIELD_MESSAGE,
  REQUIRED_FIELD_MESSAGE,
  REQUIRED_MATERIAL_MESSAGE,
  CEP_FIELD_MESSAGE,
} from '_/utils/form-validations'

function stripEmptyString(schema) {
  return schema.transform((value, original) => (original === '' ? undefined : value))
}

const materialSchema = yup.object().shape({
  description: stripEmptyString(yup.string().required(REQUIRED_FIELD_MESSAGE)),
  unid: yup.mixed().nullable().required(REQUIRED_FIELD_MESSAGE),
  quantity: stripEmptyString(yup.number().required(REQUIRED_MATERIAL_MESSAGE)),
  unitPrice: stripEmptyString(yup.number().required(REQUIRED_MATERIAL_MESSAGE)),
  total: stripEmptyString(yup.number().required(REQUIRED_MATERIAL_MESSAGE)),
})

const budgetResolutionSchema = budgetType =>
  yup.object().shape({
    service: yup.object().required(REQUIRED_FIELD_MESSAGE),
    inspectionDescription: yup.string().required(REQUIRED_FIELD_MESSAGE),
    serviceDescription: yup.string().required(REQUIRED_FIELD_MESSAGE),
    laborValue: yup.number().min(0).typeError(NUMERIC_FIELD_MESSAGE),
    ...(budgetType === 'insurance' && {
      laborValueMax: yup.number().min(0).typeError(NUMERIC_FIELD_MESSAGE),
      agencyValue: yup
        .number()
        .min(0)
        .typeError(NUMERIC_FIELD_MESSAGE)
        .required(REQUIRED_FIELD_MESSAGE),
    }),
    laborTime: yup
      .number()
      .min(0)
      .required(REQUIRED_FIELD_MESSAGE)
      .typeError(NUMERIC_FIELD_MESSAGE),
    budgetResolutionMaterials: yup.array().of(materialSchema),
  })

export const inspectionBudgetFormSchema = budgetType =>
  yup.object().shape({
    agency: yup.object().required(REQUIRED_FIELD_MESSAGE),
    ...(budgetType === 'inspection' && {
      tradesman: yup.object().required(REQUIRED_FIELD_MESSAGE),
    }),
    bitrixId: yup.number().required(REQUIRED_FIELD_MESSAGE).typeError(NUMERIC_FIELD_MESSAGE),
    propertyCode: yup.string().max(100).required(REQUIRED_FIELD_MESSAGE),
    ...(budgetType === 'insurance' && {
      clientAgency: yup.string().max(100).required(REQUIRED_FIELD_MESSAGE),
    }),
    contractCode: yup.string().max(100).notRequired(),
    executionDue: yup
      .number()
      .moreThan(0, 'Deve ser maior que 0')
      .notRequired()
      .typeError(NUMERIC_FIELD_MESSAGE),
    additionalExecutionDue: yup.number().notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    executionDueTotal: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    discount: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    percentualDiscount: yup
      .number()
      .min(0)
      .max(100, 'O valor não pode ser maior que 100')
      .notRequired()
      .typeError(NUMERIC_FIELD_MESSAGE),
    priceAgency: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    percentualPriceAgency: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    priceRefera: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    percentualPriceRefera: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    totalPriceServiceProvider: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    totalProviderWithDiscount: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    laborTime: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    squareFootage: yup.number().min(0).notRequired().typeError(NUMERIC_FIELD_MESSAGE),
    inspectionBudgetCompartments: yup.array().of(
      yup.object().shape({
        compartment: yup.string().required(REQUIRED_FIELD_MESSAGE),
        inspectionBudgetResolutions: yup.array().of(budgetResolutionSchema(budgetType)),
      })
    ),
    cep: yup
      .string()
      .notRequired()
      .matches(/^\d{5}-\d{3}$/, {
        message: CEP_FIELD_MESSAGE,
        excludeEmptyString: true,
      }),
    address: yup.string().max(255).required(REQUIRED_FIELD_MESSAGE),
    number: yup.string().max(255).required(REQUIRED_FIELD_MESSAGE),
    complement: yup.string().max(255).notRequired(),
    state: yup.string().required(REQUIRED_FIELD_MESSAGE),
    city: yup.string().required(REQUIRED_FIELD_MESSAGE),
    neighborhood: yup.string().max(255).required(REQUIRED_FIELD_MESSAGE),
  })
